import { render, staticRenderFns } from "./OfficesDriversList.vue?vue&type=template&id=1a95715e&"
import script from "./OfficesDriversList.vue?vue&type=script&lang=js&"
export * from "./OfficesDriversList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports